import styled from "styled-components";

export const ButtonWrapper = styled.div`
  padding-top: 8px;
`;
